import { useBookingFlow } from "../../context/use-booking-flow";
import { BookingSummary } from "../booking-summary/booking-summary";
import { BookingUpsell } from "../booking-upsell/booking-upsell";
import { BookingLoading } from "../booking-loading/booking-loading";
import { BookingResult } from "../booking-result/booking-result";
import {
  DefaultPoContractFlowStep,
  UpsellPoContractFlowStep,
} from "../../context/use-booking-flow/use-booking-flow.types";
import { PrivateOfficeContractsCreate } from "@/pages/private-room/contracts-create";
import { useEffect } from "react";

const StepComponents = {
  // Upsell Po Contract Flow
  [UpsellPoContractFlowStep.CREATE]: PrivateOfficeContractsCreate,
  [UpsellPoContractFlowStep.UPSELL]: BookingUpsell,
  [UpsellPoContractFlowStep.SUMMARY]: BookingSummary,
  [UpsellPoContractFlowStep.LOADING]: BookingLoading,
  [UpsellPoContractFlowStep.RESULT]: BookingResult,

  // Default Po Contract Flow
  [DefaultPoContractFlowStep.CREATE]: PrivateOfficeContractsCreate,
  [DefaultPoContractFlowStep.SUMMARY]: BookingSummary,
  [DefaultPoContractFlowStep.LOADING]: BookingLoading,
  [DefaultPoContractFlowStep.RESULT]: BookingResult,
} as const;

export const PoContractsCreateFlow = () => {
  const { currentStep, setCurrentStep } = useBookingFlow();

  useEffect(() => {
    setCurrentStep(DefaultPoContractFlowStep.CREATE);
  }, []);

  const Component = StepComponents[currentStep as keyof typeof StepComponents];

  if (!Component) {
    return <PrivateOfficeContractsCreate />;
  }

  return <Component />;
};
